<template>
  <ModelHasFiles
    :attachments="attachments"
    :max-files="3"
    :accept="acceptedMimes"
    description="Upload up to 3 documents (PDF, images, Word docs)"
    @update:attachments="updateAttachments"
  />
</template>

<script setup>
import ModelHasFiles from "./ModelHasFiles.vue";
import { ref, watch } from "vue";

const emits = defineEmits(["update:answer"]);
const props = defineProps({
  answer: Object,
  question: Object,
});

const acceptedMimes = "application/pdf,image/jpeg,image/png,image/jpg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";


const attachments = ref([]);

if (props.answer?.answer?.modelHasFiles?.screening_question) {
  attachments.value = props.answer.answer.modelHasFiles.screening_question;
}

watch(() => props.answer?.answer?.modelHasFiles?.screening_question, (newVal) => {
  if (newVal) {
    attachments.value = newVal;
  }
}, { deep: true });

const updateAttachments = (newAttachments) => {
  attachments.value = newAttachments;
  
  // Emit to parent
  emits("update:answer", {
    value: {
      modelHasFiles: {
        screening_question: newAttachments
      }
    },
    meta: { 
      fileCount: newAttachments.length 
    },
  });
};
</script>
